import { iterateRules } from ".";

function iterateStylesheets(element, scores, property) {
  var _document = document,
      styleSheets = _document.styleSheets;

  for (var styleSheetIdx in styleSheets) {
    var styleSheet = styleSheets[styleSheetIdx];
    var rules = styleSheet.cssRules || styleSheet.rules;

    if (!rules) {
      continue;
    }

    iterateRules(rules, element, scores, property);
  }
}

export { iterateStylesheets };